// extracted by mini-css-extract-plugin
export default {"closeBtn":"GoBackClosePageOverPictureButton_closeBtn__+fykL","iconX":"GoBackClosePageOverPictureButton_iconX__GLUqI"};